module.exports = __webpack_public_path__ + "img/oh.15849944.png";